import { Box, Card, CardBody, CardHeader, Container, Flex, Grid, Image, Text, useColorModeValue } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import axiosClient from '../../axios-client'
import { useTranslation } from 'react-i18next'
import imageIntrouvable from '../../assets/images/imageIntrouvable.png'
function Entreprise() {
    const navigate = useNavigate()
    const location = useLocation()
    const { t } = useTranslation();

    const [partenaire, setPartenaire] = useState([])
    const [pays, setPays] = useState([])
    const [villes, setVilles] = useState([])
    const [categories, setCategories] = useState([])


    useEffect(() => {
        axiosClient.get(`/partenaires/${location.state.idPartenaire}/`)
            .then(({ data }) => {
                setPartenaire(data)
            }).catch((error) => {
                // console.error(error);
            });

        axiosClient.get('pays/')
            .then((res) => {
                setPays(res.data);
            })
            .catch((error) => {
                // console.error(error);
            });

        axiosClient.get('villes/')
            .then((res) => {
                setVilles(res.data);
            })
            .catch((error) => {
                // console.error(error);
            });

        axiosClient.get('categories/')
            .then((res) => {
                setCategories(res.data);
            })
            .catch((error) => {
                // console.error(error);
            });
    }, []);
    const LocationMap = ({ location }) => {
        if (!location) return null;

        const [lat, lng] = location.split(',').map(coord => parseFloat(coord.trim()));

        // OpenStreetMap tile URL
        const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${lng - 0.01},${lat - 0.01},${lng + 0.01},${lat + 0.01}&layer=mapnik&marker=${lat},${lng}`;

        return (
            <Box w="100%" h="300px" borderRadius="md" overflow="hidden" border="1px solid" borderColor="gray.200">
                <iframe
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                    src={mapUrl}
                    style={{ border: 0 }}
                />
            </Box>
        );
    };

    const bgVille =useColorModeValue("blue.100", "blue.900")
    const bgCats =useColorModeValue("green.100", "green.900") 

    const cardBg =useColorModeValue("white", "gray.800")
    const cardBorder =useColorModeValue("gray.200", "gray.600") 
    return (
        <Box>
            {/* <Box
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      height="auto"
      p={0}
      position="relative"
      pt="50"
      pb="50"
      color={"black"}
    >
      <Box
        zIndex="-1"
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        backgroundColor="rgba(0, 0, 0, 0.5)" // Adjust the alpha value for transparency
      ></Box>
      <Container zIndex="2">
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          h="100%"
        >
          <Text fontSize="xl" color="white">
            Tu n'en as plus besoin ? Mets-le en vente !
          </Text>
          <Text fontSize="4xl" color="white">
            Bienvenue à Elbal
          </Text>
          <Text fontSize="lg" color="white" mt="4">
            Elbal te guide vers un avenir plus durable en donnant une nouvelle vie à tes vêtements et en dévoilant des trésors cachés. Chaque pièce a son histoire, chaque achat est une aventure unique.
          </Text>
        </Flex>
      </Container>
    </Box> */}
            <Box w={"100%"} mt={3} mb={2}>
                <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Accueil")}</span>  / <span onClick={() => navigate('/partenaires')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Partenaires")}</span> / <span> {t("Entreprise")}</span></Text>
            </Box>
            <Flex direction='column' mt={{ sm: '25px', md: '0px' }} p={{ base: 0, lg: 10 }}>

                <Grid px={{ base: 0, md: 5 }} templateColumns={{ sm: "1fr", md: "1fr", lg: "2fr 2fr " }} justify={"center"} gap='22px'>

                    <Card
                        // backgroundImage={partenaire.image}
                        display={'flex'}
                        // p='16px'
                        align={"center"}
                        justify={'center'}
                    // backgroundRepeat="no-repeat"

                    >
                        {partenaire.image
                            ? <Image src={partenaire.image} w='100%' h='100%' objectFit="conatain" />
                            : <Image src={imageIntrouvable} w='100%' h='100%' objectFit="conatain" />
                        }


                    </Card>
                    <Card
                        bg={useColorModeValue("white", "gray.700")}
                        display={'flex'}
                        p='16px'
                        boxShadow="lg"
                    >
                        <CardHeader p='12px 5px' borderBottom="2px solid" borderColor={useColorModeValue("gray.100", "gray.600")}>
                            <Text fontFamily='Plus Jakarta Display' fontSize='28px' color="#49b1cc" fontWeight='bold'>
                                {t("Détails de l'entreprise")}
                            </Text>
                        </CardHeader>
                        <CardBody px='5px' py='20px'>
                            <Flex direction='column' gap={2}>

                                {/* Company Name */}
                                <Box
                                    p={3}
                                    // bg={useColorModeValue("blue.50", "gray.800")}
                                    borderRadius="lg"
                                    borderLeft="4px solid"
                                    borderColor="#49b1cc"
                                >
                                    <Text fontSize='xs' color="gray.500" mb={1} textTransform="uppercase" letterSpacing="wide">
                                        {t("Entreprise (raison sociale)")}
                                    </Text>
                                    <Text fontSize='lg' fontWeight='600' >
                                        {partenaire?.company_name || t("Non spécifié")}
                                    </Text>
                                </Box>

                                {/* Description */}
                                {partenaire?.company_description && (
                                    <Box p={4} borderRadius="lg">
                                        <Text fontSize='xs' color="gray.500" mb={2} textTransform="uppercase" letterSpacing="wide" fontWeight="semibold">
                                            Description
                                        </Text>
                                        <Text fontSize='md' lineHeight="tall" >
                                            {partenaire?.company_description}
                                        </Text>
                                    </Box>
                                )}

                                {/* Location Info Grid */}
                                <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4}>
                                    {/* Pays */}
                                    <Box bg={cardBg} p={2} borderRadius="lg" border="1px solid" borderColor={cardBorder} >
                                        <Flex align="center" mb={2}>
                                            <Text fontSize='2xl' mr={2}>🌍</Text>
                                            <Text fontSize='xs' color="gray.500" textTransform="uppercase" letterSpacing="wide" fontWeight="semibold">
                                                {t("Pays")}
                                            </Text>
                                        </Flex>
                                        <Text fontSize='md' fontWeight='500'>
                                            {pays.find(e => e.id === parseInt(partenaire?.pays_partenaire))?.nom_pays || t("Non spécifié")}
                                        </Text>
                                    </Box>

                                    {/* Ville */}
                                    <Box bg={cardBg} p={2} borderRadius="lg" border="1px solid" borderColor={cardBorder} >
                                        <Flex align="center" mb={2}>
                                            <Text fontSize='2xl' mr={2}>🏙️</Text>
                                            <Text fontSize='xs' color="gray.500" textTransform="uppercase" letterSpacing="wide" fontWeight="semibold">
                                                {t("Ville")}
                                            </Text>
                                        </Flex>
                                        {villes.filter(e => partenaire?.ville_partenaire?.includes(e.id)).length > 0 ? (
                                            <Flex flexWrap="wrap" gap={2}>
                                                {villes.filter(e => partenaire?.ville_partenaire?.includes(e.id)).map((row, index) => (
                                                    <Box
                                                        key={index}
                                                        px={3}
                                                        py={1}
                                                        borderRadius="full"
                                                        fontSize='sm'
                                                        bg={bgVille} 
                                                        fontWeight='500'
                                                    >
                                                        {row?.nom_ville}
                                                    </Box>
                                                ))}
                                            </Flex>
                                        ) : (
                                            <Text fontSize='md' color="gray.500">{t("Non spécifié")}</Text>
                                        )}
                                    </Box>
                                </Grid>

                                {/* Activities */}
                                <Box bg={cardBg} p={4} borderRadius="lg" border="1px solid" borderColor={cardBorder} >
                                    <Flex align="center" mb={3}>
                                        <Text fontSize='2xl' mr={2}>💼</Text>
                                        <Text fontSize='xs' color="gray.500" textTransform="uppercase" letterSpacing="wide" fontWeight="semibold">
                                            {t("Activités")}
                                        </Text>
                                    </Flex>
                                    {categories.filter(e => partenaire?.category?.includes(e.id)).length > 0 ? (
                                        <Flex flexWrap="wrap" gap={2}>
                                            {categories.filter(e => partenaire?.category?.includes(e.id)).map((row, index) => (
                                                <Box
                                                    key={index}
                                                    px={4}
                                                    py={2}
                                                    bg={bgCats}
                                                    borderRadius="lg"
                                                    fontSize='sm'
                                                    fontWeight='600'
                                                    // border="1px solid"
                                                >
                                                    {row?.name}
                                                </Box>
                                            ))}
                                        </Flex>
                                    ) : (
                                        <Text fontSize='md' color="gray.500">{t("Non spécifié")}</Text>
                                    )}
                                </Box>



                            </Flex>
                        </CardBody>
                    </Card>

                </Grid>
                {partenaire?.location && (
                    <Box p={4} >
                        <Flex align="center" mb={3}>
                            <Text fontSize='2xl' mr={2}>📍</Text>
                            <Text fontSize='xs' color="gray.500" textTransform="uppercase" letterSpacing="wide" fontWeight="semibold">
                                {t("Localisation")}
                            </Text>
                        </Flex>
                        <LocationMap location={partenaire.location} />
                        <Text fontSize="xs" color="gray.500" mt={2} textAlign="center">
                            {t("Coordonnées")}: {partenaire.location}
                        </Text>
                    </Box>
                )}
            </Flex>
        </Box>
    )
}

export default Entreprise